import points from './points/points.json'
import pointsPost from './points/pointsPost.json'

export default {
  points,
  pointsPost,
}
